<template>
    <div class="content-box">
        <Title/>

        <Textlist/>
    </div>
</template>

<script>
export default {
    name: "financing",
    data() {
        return {
            params: {
                json: 0,
            }
        }
    },
    created() {
        this.$store.commit('textparams', this.params)
        this.$store.commit('changeKeys', '融资事件 社交')
        this.$store.dispatch('getText')
    }
}
</script>